module.exports = __webpack_public_path__ + "img/bar_01.93da77b3.webp";